<template>
    <div>
        <h2 class="mb-8">{{ __('store.social_media') }}</h2>
        <p v-html="__('store.profiles_info')"></p>

        <form>
            <div class="col-md-6">
                <form-group
                    :label="`<i class='la la-facebook-f'></i> Facebook - <span class='text-muted'>Optional</span>`"
                    reference-id="facebook"
                    :error="form.errors.facebook"
                >
                    <input v-model="form.facebook" id="facebook" name="facebook"
                           :class="checkError(form.errors.facebook)"
                           class="form-control" placeholder="Facebook Accountname"/>
                </form-group>

                <form-group
                    :label="`<i class='la la-instagram'></i> Instagram - <span class='text-muted'>Optional</span>`"
                    reference-id="instagram"
                    :error="form.errors.instagram"
                >
                    <input v-model="form.instagram" id="instagram" name="instagram"
                           :class="checkError(form.errors.instagram)" class="form-control"
                           placeholder="Instagram Accountname"/>
                </form-group>

                <form-group
                    :label="`<i class='la la-twitter'></i> Twitter - <span class='text-muted'>Optional</span>`"
                    reference-id="twitter"
                    :error="form.errors.twitter"
                >
                    <input v-model="form.twitter" id="twitter" name="twitter" class="form-control"
                           :class="checkError(form.errors.twitter)"
                           placeholder="Twitter Accountname"/>
                </form-group>
            </div>

            <button id="submit-edit-plan-button"
                    class="btn btn-primary"
                    @click.prevent="submitForm"
                    :disabled="form.processing">
                {{ __('actions.submit') }}
            </button>
        </form>
    </div>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import FormGroup from '@components/Form/FormGroup.vue'

export default {
    layout: Navigation,

    name: 'EditSocialProfiles',

    components: {FormGroup},

    props: {
        storeUuid: String,
        store: Object,
        profiles: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                facebook: this.profiles.facebook ?? '',
                instagram: this.profiles.instagram ?? '',
                twitter: this.profiles.twitter ?? '',
            }),
        }
    },

    methods: {
        submitForm() {
            if (this.matchesSocialUrl(this.form.facebook, 'facebook') &&
                this.matchesSocialUrl(this.form.instagram, 'instagram') &&
                this.matchesSocialUrl(this.form.twitter, 'twitter')) {
                this.form.post(this.$route('store.profile.update', this.storeUuid))
            }
        },
        checkError(message) {
            return message !== undefined ? 'is-invalid' : this.wasValidated
        },
        matchesSocialUrl(value, name) {
            let matches = value.match(/(?:https?:\/\/)?(?:www)?(?:facebook|instagram|twitter)\.\w{2,3}\/([^\/\n?#]+)/)

            if (matches && matches.length > 1) {
                this.form.setError(name,
                    `<span class="text-primary mt-1 ">
                        ${this.__('validation.custom.profiles.use')}
                     </span>`)

                this.form[name] = matches[1]

                setTimeout(() => {
                    this.form.clearErrors()
                }, 3000)

                return false
            }

            return true
        },
    },
}
</script>
